import React from "react";
import { MyAdminPanelWrapper } from "features/AdminPanel/modules/MyAdminPanelWrapper/MyAdminPanelWrapper";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { useParams } from "react-router-dom";
import { getManageOfferingRedirectUrl } from "features/ManageOfferings/utils/ManageOffering.utils";
import { BookedQuestions } from "ui/pages/QuestionsPage/BookedQuestions";
import {
  MANAGE_OFFERINGS_FEATURE_KEY,
  MANAGE_OFFERINGS_HEADER_TITLE,
} from "features/ManageOfferings/constants/ManageOfferings.constants";
import { getParamValueFromRouteProps } from "utils/Utils";
import { section_key } from "features/AdminPanel/constants/AdminPanel.constants";
import { SectionConfigWrapper } from "features/AdminPanel/modules/SectionConfigWrapper/SectionConfigWrapper";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import ExlyLoader from "ui/modules/ExlyLoader";

export const BookedQuestionsWrapper = (props) => {
  const isDesktop = useDesktopMediaQuery();
  const { listing_uuid } = useParams();
  const backUrl = getManageOfferingRedirectUrl({ listingId: listing_uuid });
  const featureKey = `${MANAGE_OFFERINGS_FEATURE_KEY}/${listing_uuid}`;
  const key = getParamValueFromRouteProps(props, section_key);
  const sectionConfigLoading = useAdminPanelStore(
    (state) => state.sectionConfigLoading
  );

  return (
    <MyAdminPanelWrapper
      featureKey={featureKey}
      classes={{
        childrenComponentStyle: `bg-transparent ${
          !isDesktop && "pt-2"
        } !tw-p-0`,
        ...(!isDesktop && { container: "px-3 top-0" }),
      }}
      hideHeader={false}
      headerTitle={
        !isDesktop ? "Booking Questions" : MANAGE_OFFERINGS_HEADER_TITLE
      }
      {...(!isDesktop
        ? {
            backUrl,
          }
        : {})}
    >
      <SectionConfigWrapper featureKey={featureKey} sectionKey={key}>
        {sectionConfigLoading ? (
          <ExlyLoader showText={false} />
        ) : (
          <BookedQuestions {...props} />
        )}
      </SectionConfigWrapper>
    </MyAdminPanelWrapper>
  );
};
